import React from 'react'
import { RoleLiteDto } from '../api/role/models/RoleDto'
import Card from './Card'
import PersonSmallPic from './PersonSmallPic'
import { useNavigate } from 'react-router-dom'
import { Pages } from '../Pages'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { MapExtra } from '../utils/MapExtra'
import { PersonLiteDto } from '../api/person/models/PersonDto'

type Props = {
    role: RoleLiteDto
    personCache: MapExtra<string, PersonLiteDto>
}

function RoleCard({ role, personCache }: Props): React.JSX.Element {
    const navigate = useNavigate()

    // const percComplete = 30

    // let shortListedCandidates = 0

    // for (const candidate of role.candidates?) {
    //     if (candidate.present) {
    //         shortListedCandidates++
    //     }
    // }

    return (
        <Card
            showTopSection={false}
            classes="w-[320px] h-[150px] bg-white"
            onClick={() => {
                navigate(`${Pages.ManageRole}?id=${role.id}`)
            }}
            footer={
                <div className="flex -space-x-2 flex-wrap">
                    {role.hiringTeamIds && role.hiringTeamIds.length > 22 ? (
                        <>
                            {role.hiringTeamIds
                                .slice(0, 21)
                                .map((hmPersonId) => (
                                    <PersonSmallPic
                                        key={hmPersonId}
                                        person={personCache.getOrThrow(
                                            hmPersonId,
                                        )}
                                        size="32px"
                                    />
                                ))}
                            <div className="w-8 h-8 bg-gray-300 flex items-center justify-center rounded-full text-xs font-medium">
                                +{role.hiringTeamIds.length - 21}
                            </div>
                        </>
                    ) : (
                        role.hiringTeamIds?.map((hmPersonId) => (
                            <PersonSmallPic
                                key={hmPersonId}
                                person={personCache.getOrThrow(hmPersonId)}
                                size="32px"
                            />
                        ))
                    )}
                </div>
            }
        >
            {/* Job Title */}
            <div className="flex-1">
                <div className="text-md font-bold mb-2 text-gray-700">
                    <FontAwesomeIcon icon={faBriefcase} className="mr-2" />
                    {role.jobTitle}
                </div>
            </div>
        </Card>
    )
}

export default RoleCard
